// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCNIDqRd8gqDbjI_0gr4IrenX-znR3aHcI",
  authDomain: "collegehub-96bbf.firebaseapp.com",
  projectId: "collegehub-96bbf",
  storageBucket: "collegehub-96bbf.appspot.com",
  messagingSenderId: "531984933282",
  appId: "1:531984933282:web:7335c7677f8cd7336ad2fb"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default app;